import { Component, OnInit, inject } from '@angular/core';
import { VersionService } from '@formbird/services';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'ft-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private router = inject(Router);


  async ngOnInit() {
    if (!window.isSecureContext && window.location.hostname !== 'localhost') {
      this.router.navigate(['/notSecure'], { skipLocationChange: true });
    } else {
      await VersionService.checkServerVersion();
    }
    
  }

}
